import { axiosInitialized, initSessionFx } from '@/shared/api'
import { createEvent, sample } from 'effector'

export const appStarted = createEvent()

sample({
  clock: appStarted,
  target: [initSessionFx, axiosInitialized],
})
